import { render, staticRenderFns } from "./UploadFilesRight.vue?vue&type=template&id=4f469a67&scoped=true&"
import script from "./UploadFilesRight.vue?vue&type=script&lang=js&"
export * from "./UploadFilesRight.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesRight.vue?vue&type=style&index=0&id=4f469a67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f469a67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
